import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CustomerFilters = ({ onFilterChange }) => {
  const [filters, setFilters] = useState({
    industry: '',
    region: '',
    customerType: '',
    status: ''
  });
  const [isExpanded, setIsExpanded] = useState(false);

  const filterOptions = {
    industry: [
      { value: '', label: 'Todas las industrias' },
      { value: 'Construcción', label: 'Construcción' },
      { value: 'Electrónica', label: 'Electrónica' },
      { value: 'Automoción', label: 'Automoción' },
      { value: 'Alimentación', label: 'Alimentación' },
      { value: 'Textil', label: 'Textil' }
    ],
    region: [
      { value: '', label: 'Todas las regiones' },
      { value: 'Madrid', label: 'Madrid' },
      { value: 'Cataluña', label: 'Cataluña' },
      { value: 'Andalucía', label: 'Andalucía' },
      { value: 'Valencia', label: 'Valencia' },
      { value: 'País Vasco', label: 'País Vasco' }
    ],
    customerType: [
      { value: '', label: 'Todos los tipos' },
      { value: 'Empresa', label: 'Empresa' },
      { value: 'Corporación', label: 'Corporación' },
      { value: 'Autónomo', label: 'Autónomo' },
      { value: 'Particular', label: 'Particular' }
    ],
    status: [
      { value: '', label: 'Todos los estados' },
      { value: 'Activo', label: 'Activo' },
      { value: 'Pendiente', label: 'Pendiente' },
      { value: 'Inactivo', label: 'Inactivo' }
    ]
  };

  const handleFilterChange = (filterType, value) => {
    const newFilters = { ...filters, [filterType]: value };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const clearAllFilters = () => {
    const clearedFilters = {
      industry: '',
      region: '',
      customerType: '',
      status: ''
    };
    setFilters(clearedFilters);
    onFilterChange(clearedFilters);
  };

  const hasActiveFilters = Object.values(filters).some(filter => filter !== '');

  return (
    <div className="card">
      <div className="p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <Icon name="Filter" size={20} className="text-text-secondary" />
            <h3 className="text-sm font-body-semibold text-text-primary">
              Filtros de Búsqueda
            </h3>
            {hasActiveFilters && (
              <span className="inline-flex items-center px-2 py-1 text-xs font-body-medium bg-primary-100 text-primary rounded-full">
                {Object.values(filters).filter(f => f !== '').length}
              </span>
            )}
          </div>
          <div className="flex items-center space-x-2">
            {hasActiveFilters && (
              <button
                onClick={clearAllFilters}
                className="text-sm text-text-secondary hover:text-text-primary transition-micro"
              >
                Limpiar Todo
              </button>
            )}
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="p-1 text-text-secondary hover:text-text-primary transition-micro lg:hidden"
            >
              <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={16} />
            </button>
          </div>
        </div>

        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 ${isExpanded ? 'block' : 'hidden lg:grid'}`}>
          {Object.entries(filterOptions).map(([filterType, options]) => (
            <div key={filterType}>
              <label className="block text-sm font-body-medium text-text-secondary mb-2 capitalize">
                {filterType === 'customerType' ? 'Tipo de Cliente' : 
                 filterType === 'industry' ? 'Industria' :
                 filterType === 'region' ? 'Región' :
                 filterType === 'status' ? 'Estado' : filterType}
              </label>
              <select
                value={filters[filterType]}
                onChange={(e) => handleFilterChange(filterType, e.target.value)}
                className="w-full px-3 py-2 border border-border rounded-md bg-surface text-text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-micro"
              >
                {options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          ))}
        </div>

        {/* Active filters display */}
        {hasActiveFilters && (
          <div className="mt-4 pt-4 border-t border-border">
            <div className="flex items-center space-x-2 flex-wrap">
              <span className="text-sm text-text-secondary">Filtros activos:</span>
              {Object.entries(filters).map(([type, value]) => 
                value && (
                  <span
                    key={type}
                    className="inline-flex items-center px-2 py-1 text-xs font-body-medium bg-primary-100 text-primary rounded-full border border-primary-200"
                  >
                    {filterOptions[type].find(opt => opt.value === value)?.label}
                    <button
                      onClick={() => handleFilterChange(type, '')}
                      className="ml-1 text-primary hover:text-primary-600 transition-micro"
                    >
                      <Icon name="X" size={12} />
                    </button>
                  </span>
                )
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerFilters;